import { useTranslation } from "react-i18next";

import { useAlert } from "@/hooks/useAlert";
import { useLocalStorageFlag } from "@/hooks/useLocalStorageFlag";
import { useQueryCallbacks } from "@/hooks/useQueryCallbacks";
import { ownErrorHandlingMeta } from "@/hooks/useQueryClient";
import { useSimIdFromQueryParam } from "@/hooks/useSimIdFromQueryParam";
import { useGetRoaming } from "@/services/api";
import { RoamingInfoRoamingStatus } from "@/services/model";
import { AlertTypes } from "@/utils/atoms";

export const useRoamingInfoForDisplayedSim = () => {
  const [simId] = useSimIdFromQueryParam();
  const showAlert = useAlert();
  const { t } = useTranslation();
  const { shouldShowError, setErrorFired } = useLocalStorageFlag(
    "roamingErrorFiredAt",
  );
  const roamingQuery = useGetRoaming(
    {
      simIds: [Number(simId)],
    },
    {
      query: {
        meta: ownErrorHandlingMeta,
        enabled: !isNaN(parseInt(simId)),
        // update the roaming Info as long as it got "ordered" items
        refetchInterval: ({ state: { data } }) => {
          if (
            data?.some(
              (roaming) =>
                roaming.roamingStatus === RoamingInfoRoamingStatus.ordered,
            )
          ) {
            return 2000;
          }

          return false;
        },
      },
    },
  );
  useQueryCallbacks(roamingQuery, {
    onError: () => {
      if (shouldShowError()) {
        // Show error message
        showAlert({
          type: AlertTypes.info,
          text: t("Error.roamingError"),
        });
        setErrorFired();
      }
    },
  });
  const { data: roamingInfo } = roamingQuery;

  return roamingInfo;
};
